import { useAuth0 } from "@auth0/auth0-react";
import { useEffect, useState } from "react";
import { NotificationContainer } from "react-notifications";
import "react-notifications/lib/notifications.css";

import { OrgRolesAndAccountProvider } from "util/OrgRolesAccountContext";
import { UnreadProvider } from "util/UnreadContext";
import AppRoutes from "AppRoutes";

import { OpenAPI } from "./client/openapi"; // generated client
import { ApiRequestOptions } from "client/openapi/core/ApiRequestOptions";

function App() {
  const { getAccessTokenSilently, isLoading, isAuthenticated } = useAuth0();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (isLoading) return; // wait until Auth0 SDK is ready

    /**
     * Wire a TOKEN resolver that will be awaited for *every* request.
     * Signature must be `(options: ApiRequestOptions) => Promise<string>`.
     * For anonymous visitors we return an empty string, which the OpenAPI
     * `getHeaders` helper treats as “no Authorization header”.
     */
    OpenAPI.TOKEN = async (_opts?: ApiRequestOptions) =>
      isAuthenticated ? await getAccessTokenSilently() : "";

    setReady(true);
  }, [isLoading, isAuthenticated, getAccessTokenSilently]);

  // Configure backend base-URL once (can also live in an env file)
  OpenAPI.BASE = process.env.REACT_APP_BACKEND_API_DOMAIN || "";

  if (!ready) return null; // splash / loader could go here

  return (
    <div className="wrapper">
      <OrgRolesAndAccountProvider>
        <UnreadProvider>
          <AppRoutes />
        </UnreadProvider>
        <NotificationContainer />
      </OrgRolesAndAccountProvider>
    </div>
  );
}

export default App;
